module.exports = __webpack_public_path__ + "static/1144444285.27e55944.jpg";